import React from "react";
import { Tab } from "@headlessui/react";
import { RfSideTab } from "../../../RfTab/RfTab";
import { Chip } from "../../../Chip";

export type ImageMode = "hosted" | "in-app" | "local";
export type VideoMode = "api" | "in-app" | "local";

interface DeploySidebarProps {
    dataType: number;
    currentImageMode: ImageMode;
    currentVideoMode: VideoMode;
    onDataTypeChange: (type: number) => void;
    onImageModeChange: (mode: ImageMode) => void;
    onVideoModeChange: (mode: VideoMode) => void;
    isWorkflowEditor?: boolean;
}

const IMAGE_MODES: ImageMode[] = ["hosted", "in-app", "local"];
const VIDEO_MODES: VideoMode[] = ["api", "in-app", "local"];

export function DeploySidebar({
    dataType,
    currentImageMode,
    currentVideoMode,
    onDataTypeChange,
    onImageModeChange,
    onVideoModeChange,
    isWorkflowEditor = true
}: DeploySidebarProps) {
    const handleDataTypeChange = (newDataType: number) => {
        const currentIndex =
            dataType === 0
                ? IMAGE_MODES.indexOf(currentImageMode)
                : VIDEO_MODES.indexOf(currentVideoMode);

        if (newDataType === 0) {
            onImageModeChange(IMAGE_MODES[currentIndex]);
        } else {
            onVideoModeChange(VIDEO_MODES[currentIndex]);
        }

        onDataTypeChange(newDataType);
    };

    return (
        <div className="sidebarTabs opacity-100 transition-all duration-300 ease-in-out sm:w-64">
            {/* Section 1: Data Type */}
            <div className="section">
                <div className="sectionTitle">
                    <Chip type="number" color="purple">
                        1
                    </Chip>
                    What type is your data?
                </div>
                <Tab.Group selectedIndex={dataType} onChange={handleDataTypeChange}>
                    <Tab.List className="sidebarTabList">
                        <RfSideTab>
                            <i className="fa-fw fad fa-image" /> Images
                        </RfSideTab>
                        <RfSideTab>
                            <i className="fa-fw fad fa-video" /> Video
                        </RfSideTab>
                    </Tab.List>
                </Tab.Group>
            </div>

            {/* Section 2: Deployment Mode */}
            <div className="section">
                <div className="sectionTitle">
                    <Chip type="number" color="purple">
                        2
                    </Chip>
                    Where should it run?
                </div>
                <Tab.Group
                    selectedIndex={
                        dataType === 0
                            ? IMAGE_MODES.indexOf(currentImageMode)
                            : VIDEO_MODES.indexOf(currentVideoMode)
                    }
                    onChange={(index) => {
                        if (dataType === 0) {
                            onImageModeChange(IMAGE_MODES[index]);
                        } else {
                            onVideoModeChange(VIDEO_MODES[index]);
                        }
                    }}
                >
                    <Tab.List className="sidebarTabList">
                        <RfSideTab className="flex w-full items-center justify-between">
                            <span className="flex items-center gap-2">
                                <i className="fa-fw fad fa-cloud" /> API
                            </span>
                            {isWorkflowEditor && (
                                <Chip color="green" size="xs">
                                    <i className="far fa-star" />
                                </Chip>
                            )}
                        </RfSideTab>
                        <RfSideTab>
                            <i className="fa-fw fad fa-window-alt" /> Batch Processing
                        </RfSideTab>
                        <RfSideTab>
                            <i className="fa-fw fad fa-laptop" /> Local Server
                        </RfSideTab>
                    </Tab.List>
                </Tab.Group>
            </div>
        </div>
    );
}
